import React, { FC } from 'react';

import { Error, ErrorWrapper, Icon, Info, Success } from './toast.styled';
import { ToastType } from './types';

export const ToastTypeLogo: FC<{ type: ToastType }> = ({ type }) => {
  switch (type) {
    case ToastType.SUCCESS:
      return (
        <Icon>
          <Success isActive />
        </Icon>
      );
    case ToastType.INFO:
      return (
        <Icon>
          <Info>!</Info>
        </Icon>
      );
    case ToastType.WARN:
      return (
        <Icon>
          <ErrorWrapper>
            <Error />
          </ErrorWrapper>
        </Icon>
      );
    case ToastType.ERROR:
      return (
        <Icon>
          <ErrorWrapper>
            <Error />
          </ErrorWrapper>
        </Icon>
      );
    default:
      return null;
  }
};
